/**
 * Contact search responses.
 *
 * Make sure all search string data is lowercase.
 *
 * @type {array}
 */
const contactSearch = {

	'email': [
		{
			string: [ 'brushninja.com', 'brush.ninja', 'brushninja' ],
			message: `<p>Invalid email address.</p>`,
		},
		{
			string: [ 'visualads.com', 'dominatingkeywords.com' ],
			message: `<p>Thank you, but we are not in need of your services.</p>`,
		},
		{
			string: [ 'eddychevezmedina@hpcsd.org', 'eddychevezmedina' ],
			disable: true,
		},
		// {
		// 	string: [ 'darya@kennedy' ],
		// 	message: `<p>Hi Darya. Please stop sending me emails, I have tried replying but the email address does not work.</p>
		// 	<p>To answer your questions.</p>
		// 	<ul>
		// 		<li>I am a real person, but the chat widget isn't (although I made it).</li>
		// 		<li>Thanks for the offer but I don't need any help with spam.</li>
		// 		<li>It's spelt ninja, not ninga.</li>
		// 		<li>Draw an animation of a cat dancing.</li>
		// 	</ul>
		// 	<p>All the best, Ben.</p>`,
		// },
		// {
		// 	string: [ 'amy@dinkins' ],
		// 	message: `<p>Hi Amy/ Darya. If you're going to email someone then please use an email address that person can reply to.</p>
		// 	<p>I won't be replying to any more emails from you. I will block your addresses.</p>
		// 	<p>All the best, Ben</p>`,
		// },
		// {
		// 	string: [ 'henricostudents', 'henrico' ],
		// 	message: `<p>Hi there. I don't know why but I'm afraid I can't reply to emails on this domain. If you could talk to your teachers/ lecturers about this and get them to allow emails from brushninja.com then I would be happy to reply to your emails.</p>
		// 	<p>All the best, Ben.</p>`,
		// },
		{
			string: [ '@domain', '@domian', 'name@', 'ma.caleb83@gmail.com' ],
			message: `<p>To get a reply you need to use a real email address. If you don't have one then please ask an adult to help.</p>`,
		},
	],

	'name': [
	],

	'message': [
		{
			string: [ 'save' ],
			message: `<p>Click here for information about how to <a href="https://brush.ninja/help/saving-animations/">save your animation</a>.</p>`
		},
		{
			string: [ 'godaddy', 'buy now', 'domain name', 'keywords' ],
			message: `<p>I'm not interested in buying your domain name or seo service.</p>`
		},
		{
			string: [ 'music', 'sound' ],
			message: `<p>Brush Ninja does not support sound or music. This is because Brush Ninja creates animated gifs, a format that doesn't support audio.</p>`
		},
		{
			string: [ 'speed', 'slower', 'faster', 'too quick' ],
			message: `<p>You can speed up or slow down an animation by clicking the guage icon next to the play button.</p>`
		},
		{
			string: [ 'brush ninga', 'ninga' ],
			message: `<p>The website is called <strong>Brush <em>Ninja</em></strong>, not <strong>Ninga</strong></p>`,
		},
		{
			string: [ 'gdpr', 'privacy', 'coppa', 'hippa', 'soc 2', 'soc 3', 'ferpa', 'edlaw 2d' ],
			message: '<p>Please read the <a href="/privacy-policy/">privacy policy</a> as many privacy & safety related questions are answered there.</p>'
		},
		{
			string: [ 'guest post', 'sponsored post' ],
			message: `<p>Sorry, but I don't accept guest posts or sponsored posts.</p>`
		},
		// {
		// 	string: [ 'coppa', 'ferpa', 'edlaw 2d' ],
		// 	message: `<p>While Brush Ninja has not undergone formal review, we affirm to the best of our knowledge that it complies with COPPA, FERPA, and EdLaw 2-d regulations.</p>`
		// },
		{
			string: [ 'cancel subscription', 'subscription', 'cancel', 'unsubscribe', 'refund', 'end payment' ],
			message: `<p>If you wish to cancel your membership subscription then you can do so through the <a href="${ninja_props.stripe_account}">Stripe billing page</a>.</p>`,
		}
	],

};

//==require generate-ip-code.js

; ( function() {

	const thanks = '/contact-thanks/';

	/**
	 *
	 */
	const changeFormAction = ( action = 'https://formspree.io/f/xpzownnb' ) => {

		let method = 'POST';
		if ( action === thanks ) {
			method = 'GET';
		}

		const form = document.getElementById( 'contact-form' );

		form.action = action;
		form.method = method;

	};

	/**
	 * Check sender email.
	 */
	const checkSenderEmail = function( e ) {

		var value = e.target.value.toLowerCase();

		document.getElementById( 'contactSubmit' ).disabled = false;

		const errors = document.querySelectorAll( '.error' );
		for ( var i = 0; i < errors.length; i++ ) {
			errors[ i ].style.display = 'none';
		}

		checkContent( contactSearch.email, value, 'replyContactEmail' );

	};


	/**
	 * Check sender name.
	 */
	const checkSenderName = function( e ) {

		var value = e.target.value.toLowerCase();

		document.getElementById( 'contactSubmit' ).disabled = false;

		// Darya@Kennedy.com
		if ( value === '.' ) {
			document.getElementById( 'contactSubmit' ).disabled = true;
		}

		checkContent( contactSearch.name, value, 'replyContactName' );

	};


	/**
	 * Checker message content.
	 */
	const checkSenderMessage = function( e ) {

		changeFormAction();

		var value = e.target.value.toLowerCase();

		// document.getElementById( 'contactSubmit' ).disabled = false;

		checkContent( contactSearch.message, value );

		// Check spaces.
		const spaces = value.split( ' ' ).length;
		if ( spaces < 3 ) {
			changeFormAction( thanks );
		}

		// Longest word.
		// Make sure there's no super long text strings.
		if ( longestWord( value ) > 32 ) {
			changeFormAction( thanks );
		}

	};


	/**
	 * Work out the length of the longest word in a string.
	 *
	 * @param {string} str The string.
	 * @return {int}
	 */
	const longestWord = ( str ) => {

		let longestWord = str.split( ' ' ).sort( ( a, b ) => { return b.length - a.length; } );
		return longestWord[ 0 ].length;

	};


	/**
	 * Check the entered content against the submission data.
	 */
	const checkContent = function( searchList, value, displayElement = 'replyContactMessage' ) {

		value = value.toLowerCase();

		if ( searchList.length <= 0 ) {
			return;
		}

		searchList.forEach(
			( search ) => {

				let react = false;
				search.string.forEach(
					( keyword ) => {
						if ( value.includes( keyword ) ) {
							react = true;
						}
					}
				);

				if ( react ) {

					if ( search.message ) {
						const errorDiv = document.getElementById( displayElement );
						errorDiv.style.display = 'block';
						errorDiv.innerHTML = search.message;
					}

					if ( search.disable ) {
						document.getElementById( 'contactSubmit' ).disabled = true;
					}

				}

			}
		);

	};

	document.getElementById( '_replyto' ).addEventListener( 'change', checkSenderEmail );
	document.getElementById( '_replyto' ).addEventListener( 'keyup', checkSenderEmail );

	document.getElementById( 'name' ).addEventListener( 'change', checkSenderName );
	document.getElementById( 'name' ).addEventListener( 'keyup', checkSenderName );

	document.getElementById( 'message' ).addEventListener( 'change', checkSenderMessage );
	document.getElementById( 'message' ).addEventListener( 'keyup', checkSenderMessage );

	generateGen.init();

} )();
